import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface Objection {
  question: string;
  answer: string;
}
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const objections: Objection[] = [{
    question: '¿Es solo teoría o tiene contenido práctico?',
    answer: 'Es 100% práctico. Cada capítulo tiene procedimientos paso a paso, tips de técnicos con experiencia, y soluciones a errores comunes. No hay relleno teórico, solo lo que necesitás para trabajar.'
  }, {
    question: '¿Sirve si recién empiezo o necesito experiencia previa?',
    answer: 'Está diseñado para que lo aproveches desde el día uno, seas principiante o tengas experiencia. Si recién empezás, te ahorra años de ensayo y error. Si ya trabajás, vas a encontrar técnicas y conocimientos que te van a hacer más eficiente.'
  }, {
    question: '¿Está actualizado con las técnicas modernas?',
    answer: 'Sí, incluye tanto técnicas tradicionales (que seguís necesitando) como flujo digital, CAD/CAM, zirconia, impresión 3D y todo lo que se usa en laboratorios modernos.'
  }, {
    question: '¿Puedo acceder desde cualquier dispositivo?',
    answer: 'Sí, es 100% digital en formato PDF. Lo descargás y lo tenés para siempre en tu compu, tablet o celular. Sin vencimientos ni restricciones.'
  }, {
    question: '¿Los bonos realmente son gratis?',
    answer: 'Sí, por tiempo limitado los 5 bonos están incluidos sin costo adicional. Son herramientas que normalmente venderíamos por separado, pero queremos que tengas todo lo necesario para arrancar bien.'
  }, {
    question: '¿Qué pasa si no me sirve?',
    answer: 'Estamos seguros de que te va a servir porque está basado en años de experiencia real en laboratorios. Pero si por alguna razón no cumple tus expectativas, contactanos a EbookDreamShop@gmail.com y lo resolvemos.'
  }];
  const toggleObjection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full px-4 py-12 bg-white" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-99">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-100">
          {objections.map((objection, index) => <div key={index} className="bg-gray-50 rounded-lg shadow-md overflow-hidden" data-id="element-101">
              <button onClick={() => toggleObjection(index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-100 transition-colors" data-id="element-102">
                <h3 className="text-lg font-semibold text-gray-900 pr-4" data-id="element-103">
                  {objection.question}
                </h3>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-104" /> : <ChevronDownIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-105" />}
              </button>

              {openIndex === index && <div className="px-5 pb-5 pt-2" data-id="element-106">
                  <p className="text-gray-700" data-id="element-107">{objection.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}